import HomeBanner from "../components/Banner/HomeBanner";
import CategoryBox from "../components/Category/CategoryBox";
import Footer from "../components/Footer/Footer";
import Navigation from "../components/Navigation/Navigation";
import HomeSearch from "../components/Search/HomeSearch";
import Spinner from "../components/Spinner/Spinner";

function Home() {
  return (
    <div className="container-xxl bg-white p-0">
      <Spinner />
      <Navigation />
      <HomeBanner />
      <HomeSearch />
      <CategoryBox />
      <Footer />
    </div>
  );
}

export default Home;
